// src/pages/StudyNotesPage.js
import React, { useState } from 'react';
import { Container, Row, Form, InputGroup, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import StudyNoteCard from '../components/StudyNoteCard';
import { studyNotes } from '../data/studyNotes';

function StudyNotesPage() {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('');

  // Get unique categories
  const categories = [...new Set(studyNotes.map(note => note.category))];

  // Filter notes based on search and category
  const filteredNotes = studyNotes.filter(note => {
    const matchesSearch = note.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         note.content.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         note.tags.some(tag => tag.toLowerCase().includes(searchTerm.toLowerCase()));
    
    const matchesCategory = selectedCategory ? note.category === selectedCategory : true;
    
    return matchesSearch && matchesCategory;
  });

  return (
    <Container className="mt-4">
      {/* Header */}
      <div className="text-center mb-5">
        <h1>Study Notes & Blog</h1>
        <p className="lead">
          Explore my learning journey through written notes, video explanations, and podcast discussions.
        </p>
      </div>

      {/* Search and Filter Section */}
      <Row className="mb-4">
        <div className="col-md-6 mb-2">
          <InputGroup>
            <InputGroup.Text>🔍</InputGroup.Text>
            <Form.Control
              type="text"
              placeholder="Search notes, tags, or content..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </InputGroup>
        </div>
        
        <div className="col-md-4 mb-2">
          <Form.Select
            value={selectedCategory}
            onChange={(e) => setSelectedCategory(e.target.value)}
          >
            <option value="">All Categories</option>
            {categories.map(category => (
              <option key={category} value={category}>
                {category}
              </option>
            ))}
          </Form.Select>
        </div>

        <div className="col-md-2 mb-2">
          <Button 
            as={Link} 
            to="/" 
            variant="outline-secondary" 
            className="w-100"
          >
            ← Home
          </Button>
        </div>
      </Row>

      {/* Results Count */}
      <div className="mb-3">
        <small className="text-muted">
          Showing {filteredNotes.length} of {studyNotes.length} notes
          {selectedCategory && ` in ${selectedCategory}`}
        </small>
      </div>

      {/* Study Notes Grid */}
      <Row>
        {filteredNotes.length > 0 ? (
          filteredNotes.map(note => (
            <div key={note.id} className="col-lg-4 col-md-6 mb-4">
              <StudyNoteCard note={note} />
            </div>
          ))
        ) : (
          <div className="col-12 text-center py-5">
            <h4>No study notes found</h4>
            <p>Try adjusting your search or filter criteria.</p>
            <Button 
              variant="outline-primary" 
              onClick={() => {
                setSearchTerm('');
                setSelectedCategory('');
              }}
            >
              Clear Filters
            </Button>
          </div>
        )}
      </Row>
    </Container>
  );
}

export default StudyNotesPage;